import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {
  UiOrganismCookieBannerComponent
} from '@shared/components/organisms/ui-organism-cookie-banner/ui-organism-cookie-banner.component';

@Component({
  selector: 'app-simple-layout',
  imports: [
    RouterOutlet,
    UiOrganismCookieBannerComponent
  ],
  templateUrl: './simple-layout.html'
})
export class SimpleLayout {

}
